import { useState, useEffect, useRef } from "react";
import type { TimelineEvent } from "../../../../eventsTimelineComponent/types";
import type { GetTimelineEventsResponse } from "@services/demo/msoffice/types";

export function useShipmentTimeline(
  shipmentId: string | null,
  fetchTimeline: (shipmentId: string) => Promise<GetTimelineEventsResponse>
) {
  const [events, setEvents] = useState<TimelineEvent[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTimelineRef = useRef(fetchTimeline);
  fetchTimelineRef.current = fetchTimeline;

  useEffect(() => {
    if (!shipmentId) {
      setEvents([]);
      setLoading(false);
      setError(null);
      return;
    }

    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetchTimelineRef.current(shipmentId);
        setEvents(response.events);
      } catch (err) {
        console.error("Error fetching shipment timeline:", err);
        setError("Failed to load timeline");
        setEvents([]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [shipmentId]);

  return { events, loading, error };
}
